export default {
  CLEAR_DATA: Symbol('CLEAR_DATA'),
  SAVE_DATA: Symbol('SAVE_DATA'),
  TOGGLE_LOADING: Symbol('TOGGLE_LOADING'),
  SET_PAGINATION: Symbol('SET_PAGINATION'),
  RESET_PAGINATION: Symbol('RESET_PAGINATION'),
  SET_TIME: Symbol('SET_TIME'),
  RESET: Symbol('RESET'),
  COMSUMPTION_ITEM_LIST: Symbol('COMSUMPTION_ITEM_LIST'),
  FRONT_CONSUME: Symbol('FRONT_CONSUME'),
  FRONT_CONSUME_LIST: Symbol('FRONT_CONSUME_LIST'),
  UPDATE_FRONT_CONSUME: Symbol('UPDATE_FRONT_CONSUME'),
  REFUND_PAGE: Symbol('REFUND_PAGE'),
  FORCE_TO_REFUND: Symbol('FORCE_TO_REFUND'),
  RETRY_REFUND: Symbol('RETRY_REFUND'),
  GET_ORDER_DETAIL: Symbol('GET_ORDER_DETAIL'),
  GET_GOODS_DETAIL: Symbol('GET_GOODS_DETAIL'),
  SET_GOODS_DETAIL: Symbol('SET_GOODS_DETAIL'),
};
